/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React from 'react'
import bowser from 'bowser'
import './UnsupportedBrowser.css'
import logoImg from '../assets/img/nogame-logo.svg'
import botImg from '../assets/img/tracebot_sad@3x.png'

const UnsupportedBrowser = (props) => {
    return (
        <div className="UnsupportedBrowser no-game-splash">
            <img className="no-game-logo" src={logoImg} alt="Trace" />
            <h1>Shucks. Your browser and I are not getting along.</h1>
            {!bowser.ios && <p>Please refer to our <a href="http://www.tracesoccer.com/posts/supported-browsers/" target="_blanc">supported browsers</a> list.</p>}
            {bowser.ios && <p>Please make sure you have updated to the latest version of iOS.</p>}
            <img className="no-game-bot" src={botImg} alt="Trace Bot" />
        </div>
    )
}

export default UnsupportedBrowser
